import { render, staticRenderFns } from "./AuthAdminConsent.vue?vue&type=template&id=1cd6924d&scoped=true&"
import script from "./AuthAdminConsent.vue?vue&type=script&lang=ts&"
export * from "./AuthAdminConsent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6924d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd6924d')) {
      api.createRecord('1cd6924d', component.options)
    } else {
      api.reload('1cd6924d', component.options)
    }
    module.hot.accept("./AuthAdminConsent.vue?vue&type=template&id=1cd6924d&scoped=true&", function () {
      api.rerender('1cd6924d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthAdminConsent.vue"
export default component.exports